import { useState, useEffect } from 'react';
import {
  calculatePriceRange,
  buildRegimenList,
} from '../components/HotelFiltersDialog/filtersUtils';

const useHotelFiltersState = ({
  hotelSearchResults,
  filter,
  priceRange,
  pricesFiltered,
  setFilter,
  setPriceRange,
  setPricesFiltered,
  handelFilterAplicated,
  totalNights,
  handleClose,
  handleClearFilterAplicated,
}) => {
  const [currentSelectedRegimen, setCurrentSelectedRegimen] = useState(filter);
  const [availableRegimens, setAvailableRegimens] = useState([]);

  const updateAvailableRegimens = () => {
    const list = buildRegimenList(hotelSearchResults);
    setAvailableRegimens(list);
  };

  const handleRegimenChange = regimen => {
    setCurrentSelectedRegimen(regimen);
    setFilter(regimen);
    recalculatePriceRange(regimen);
  };

  const [calculatedMinPrice, setCalculatedMinPrice] = useState(
    priceRange[0] || 0
  );
  const [calculatedMaxPrice, setCalculatedMaxPrice] = useState(
    priceRange[1] || 0
  );

  const [userFilteredMinPrice, setUserFilteredMinPrice] = useState(
    pricesFiltered?.[0] === undefined ? '' : String(pricesFiltered[0])
  );

  const [userFilteredMaxPrice, setUserFilteredMaxPrice] = useState(
    pricesFiltered?.[1] === undefined ? '' : String(pricesFiltered[1])
  );

  const handlePriceInputChange = (value, type) => {
    if (type === 1) {
      setUserFilteredMinPrice(value);

      setPricesFiltered([
        Number(value) || 0,
        Number(userFilteredMaxPrice) || calculatedMaxPrice,
      ]);
    }

    if (type === 2) {
      setUserFilteredMaxPrice(value);

      setPricesFiltered([
        Number(userFilteredMinPrice) || calculatedMinPrice,
        Number(value) || 0,
      ]);
    }
  };

  const recalculatePriceRange = regimen => {
    const [minPrice, maxPrice] = calculatePriceRange(
      hotelSearchResults,
      totalNights,
      regimen
    );

    setCalculatedMinPrice(minPrice);
    setCalculatedMaxPrice(maxPrice);

    setUserFilteredMinPrice(String(minPrice));
    setUserFilteredMaxPrice(String(maxPrice));

    setPriceRange([minPrice, maxPrice]);
    setPricesFiltered([minPrice, maxPrice]);
  };

  const resetFilters = () => {
    recalculatePriceRange('allOptions');

    setCurrentSelectedRegimen('allOptions');
    setFilter('allOptions');

    handleClearFilterAplicated();

    handleClose();
  };

  const applyFilters = () => {
    handelFilterAplicated();
    handleClose();
  };

  useEffect(() => {
    updateAvailableRegimens();
    recalculatePriceRange(currentSelectedRegimen);
  }, [hotelSearchResults]);

  return {
    currentSelectedRegimen,
    setCurrentSelectedRegimen,
    availableRegimens,
    calculatedMinPrice,
    calculatedMaxPrice,
    userFilteredMinPrice,
    userFilteredMaxPrice,
    setUserFilteredMinPrice,
    setUserFilteredMaxPrice,
    handlePriceInputChange,
    handleRegimenChange,
    resetFilters,
    applyFilters,
  };
};

export default useHotelFiltersState;
